import { Injectable } from '@angular/core';
import { ProductOptionWithSubrole } from '@app/core/interfaces/product-option-with-subrole';
import { ProductOptionRepository } from '@app/core/repositories/product-option.repository';
import { CachedHelperService } from '@app/shared/services/cached-helper.service';
import { Cached } from '@app/utils/cached';

@Injectable({
  providedIn: 'root',
})
export class ProductOptionService {
  private _productOptions: Cached<ProductOptionWithSubrole[]> | null = null;

  get productOptions(): Cached<ProductOptionWithSubrole[]> {
    this._productOptions ??= this.cachedHelperService.routeAwareCached({
      dataProducer: () => this.productOptionRepository.listProductOptions(),
      id: ([serviceProviderId]) => `service-provider:${serviceProviderId}:product-options`,
      routeParameters: ['serviceProviderId'],
    });

    return this._productOptions;
  }

  constructor(
    private cachedHelperService: CachedHelperService,
    private productOptionRepository: ProductOptionRepository
  ) {}
}
